
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDiscountBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 144,
  height: 51,
  viewBox: "0 0 144 51"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5.9h138.6l-15.846 43.576a9 9 0 0 1-8.458 5.924H4.5a3.6 3.6 0 0 1-3.6-3.6V4.5A3.6 3.6 0 0 1 4.5.9z",
  fill: "#F2F2F2",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"144\" height=\"51\" viewBox=\"0 0 144 51\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#F2F2F2\">\r\n            <g>\r\n                <path d=\"M13.5.9h138.6l-15.846 43.576c-1.293 3.556-4.673 5.924-8.458 5.924H13.5c-1.988 0-3.6-1.612-3.6-3.6V4.5c0-1.988 1.612-3.6 3.6-3.6z\" transform=\"translate(-25 -536) translate(16 536)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/discount-bg.27a7c6556c2128abf2b1d9209222a526.svg"),
        {
          React: SvgDiscountBg,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      